import { ConfigProvider, App as AntdApp } from 'antd'
import { ThemeProvider } from 'antd-style'

import { CommonGlobalStyle } from '@eastcoal/common/style/global'

import { Router } from '@eastcoal/router/components/Router'
import { ApplicationType } from '@eastcoal/shared/enums/ApplicationType'
import { DeviceType } from '@eastcoal/shared/enums/DeviceType'
import { useAppRefreshSubscriber } from '@eastcoal/shared/hooks/useAppRefresh'

import { antdConfig } from './config/antd'
import { customToken } from './config/antd-style'
import { routes } from './routes'
import { APP_VERSION } from './utils/constants'

export const App = () => {
  useAppRefreshSubscriber({
    deviceType: DeviceType.PC,
    app: ApplicationType.MALL,
    version: APP_VERSION
  })
  return (
    <ThemeProvider customToken={customToken}>
      <ConfigProvider {...antdConfig}>
        <AntdApp>
          <CommonGlobalStyle />
          <Router items={routes} />
        </AntdApp>
      </ConfigProvider>
    </ThemeProvider>
  )
}
